module.exports = __webpack_public_path__ + "img/quicksupport_ad.520ec69b.svg";